import { formatDateTimeForFileName } from '@backrs_ui/common-ui';

import { pdf, Font } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';

import { ResultDocumentPDF, ResultDocumentPDFProps } from './ResultDocument';

const BLUEPRINT_URL = process.env.REACT_APP_GROW_URL;

Font.register({
  family: 'Sarabun',
  fonts: [
    {
      src: `${BLUEPRINT_URL}/Sarabun-Regular.ttf`,
      fontWeight: 'normal',
    },
    {
      src: `${BLUEPRINT_URL}/Sarabun-Bold.ttf`,
      fontWeight: 'bold',
    },
  ],
});

/** ABOUT
 *
 * This function generates a PDF document with the user's survey results. We have to use the react-pdf library and its components to generate the PDF. This does mean that we are duplicating the code to generate the PDF and show the results on the web, but it's a necessary tradeoff to generate the PDF.
 *
 * To modify, make sure you use View/Text instead of <div> and <p> tags. You can also use the StyleSheet.create function to create styles for your components.
 */
export async function downloadPDF({
  tier,
  entrepreneurshipRecommended,
  userResponseSet,
  careerPathSuggestions,
  careerQuestions,
  careerPathCategories,
  firstName,
  lastName,
  createdAt,
}: ResultDocumentPDFProps) {
  const PDFContent = await ResultDocumentPDF({
    tier,
    entrepreneurshipRecommended,
    userResponseSet,
    careerPathSuggestions,
    careerQuestions,
    careerPathCategories,
    firstName,
    lastName,
    createdAt,
  });

  // Generate the PDF as a blob
  const pdfBlob = await pdf(PDFContent).toBlob();

  // is there is a first and last name, we format like: LastName-FirstName Blueprint 10-29-2024 1-27pm.pdf
  // if there is no first and last name, we format like: My Blueprint 10-29-2024 1-27pm.pdf
  const nameToUse = firstName || lastName ? `${lastName}-${firstName}` : 'My';

  const fileName = `${nameToUse} Blueprint ${formatDateTimeForFileName(createdAt)}.pdf`;

  // Save the PDF blob using file-saver
  saveAs(pdfBlob, fileName);
}
